import React, { useEffect, useState } from "react";
import { Modal, Button, Placeholder, Whisper, Tooltip } from "rsuite";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { axiosPost, axiosUpdate } from "../../../common/utils/helper";
import { PostSource, UpdateSource } from "../../../common/utils/api";
import { EPInput } from "../../../common/controls";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import Loader from "../../Loader/loader";
import { Info } from "../../../common/controls/info";

interface ReqBody {
  SourceName: String;
}
interface Props {
  open: boolean;
  action?: string;
  isValidate?: boolean;
  refresher?: boolean;
  setRefresher?: any;
  singleData?: any;
  setOpen: (open: boolean) => void;
}
export default function AddSourceModal(props: Props) {
  const { open, setOpen, action, setRefresher, singleData, refresher } = props;
  const [SourceName, setSourceName] = useState<string>(
    singleData?.SourceName ? singleData?.SourceName : ""
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [UpdateDisable, setUpdateDisable] = useState<boolean>(true)
  const [isValidate, setIsValidate] = useState(false);
  const regexPattern =  /^[A-Za-z\s]+$/;
  
  let response: AxiosResponse;
  function closeModal() {
    setOpen(false);
  }
  function handleKeyPress(event: any) {
    if (!regexPattern.test(event.target.value + event.key)) {
      event.preventDefault();
    }
  }

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event?.key === "Enter" && !loading) {
      handleSubmit();
    }
  }

  async function handleSubmit() {
    if (SourceName?.trim().length < 1) {
      setIsValidate(true);
      toast.error("Please fill the mandatory field", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    } else {
      action === "Add"
        ? await postSourceName(PostSource, SourceName.trim())
        : await updateSourceName(`${UpdateSource}/${singleData.SourceId}`, {
            SourceName: SourceName.trim(),
          });
      refresher ? setRefresher(false) : setRefresher(true);
      closeModal();
    }
  }

  async function postSourceName(reqUrl: string, reqBody: string) {
    setLoading(true);
    response = (await axiosPost(reqUrl, { reqBody })) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL && response.data?.status === "success") {
      setLoading(false);
      toast.success("Source saved successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (response.status == CommonConstants.API_RESPONSE_SUCCESSFULL && response.data?.status === "error") {
      setLoading(false);
      toast.warning("Source already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  async function updateSourceName(reqUrl: string, reqBody: ReqBody) {
    response = (await axiosUpdate(reqUrl, reqBody)) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL && response.data?.status === "success") {
      toast.success("Source updated successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (response.status == CommonConstants.API_RESPONSE_SUCCESSFULL && response.data?.status === "error") {
      toast.warning("Source already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  function handleSourceChange(value: string) {
    setUpdateDisable(false)
    setSourceName(value);
  }
  return loading ? (
    <Loader />
  ) : (
    <>
      <Modal open={open} onClose={closeModal} className="modal-sm" backdrop="static" keyboard={false} onKeyDown={handleModalKeyDown}>
        <Modal.Header>
          <Modal.Title>{action} source</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Source<span className="text-danger">* </span>
          <Info message="Minimum 1 characters, Maximum 100 characters" />
          <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
            <EPInput
              onKeyPress={handleKeyPress}
              label="Source"
              minlength={1}
              maxlength={100}
              style={{ width: 100 }}
              onChange={handleSourceChange}
              value={SourceName}
              isValidate={isValidate}
            />
          </Whisper>
        </Modal.Body>
        <Modal.Footer>
          <Button
          disabled={action === "Edit" && UpdateDisable}
          
            onClick={handleSubmit}
            className="float-start"
            appearance="primary"
          >
            {action === "Edit" ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
